/**
 * Determine the content of tooltip for a control. May return empty string, meaning tooltip doesn't need to be shown.
 * @param hideLabel Whether the label for the control is currently hidden
 * @param label The label text for the control
 * @param customTooltip The custom tooltip text for the control
 */
export function getTooltipText(
  hideLabel: boolean | undefined,
  label: string,
  customTooltip: string | undefined
): string {
  if (hideLabel || hideLabel === undefined) {
    return customTooltip || label;
  }

  // If label is shown, only display tooltip if it has different text than the label (with `customTooltip`).
  if (customTooltip && customTooltip !== label) {
    return customTooltip;
  }
  return "";
}
